
import { Home }  from '@/app/home'

export default function index() {
  return (
    <Home></Home>
  );
}
